import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance';
import {
  RoomAdd,
  RoomMaList,
  CityFilterAction,
  buildingFilterAction,
  TowerFilterAction,
  FloorFilterAction,
} from '../../Redux/action/roomTraingAction';
import { dataUser } from '../Helpers/util';

import SwInput from '../Common/FormComponent/SwInput';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwSwitchButtons from '../Common/SwSwitchButtons/SwSwitchButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDUpload from '../Common/AntDUpload/AntDUpload';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class AddRoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setcolor: false,
      image: null,
      fileName: null,
      uploading: false,
      hidVal: false,
      dataAdd: false,
      company_id: UserObj.company_id,
      added_by: UserObj.email,

      buildingOptions: [], // For the building dropdown
      floorOptions: [], // For the floor dropdown
      selectedBuilding: null, // Selected building object
      selectedFloor: null,
      selectedBuildingId: null, // Selected building object
      selectedFloorId: null,
      trainingRoomList: [],
      cityApiData: [],
      buildingApiData: [],
      TowerApiData: [],
      FloorApiData: [],
      buildingCheck: false,
      nfile: null,

      meetingroom_code: '',
      room_image: null,
      building_id: '',
      tower_id: '',
      floor_id: '',
      room_type: '',
      status: '',
      no_of_seats: '',
      time_slot: '',
      price_per_slot: '',
      meeting_alltime: false,
      meeting_opentime: '',
      meeting_closetime: '',
      bookingEdit24:false,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],

    };
    this.fileInputRef = React.createRef();
  }

  setColor = e => {
    this.setState({
      setcolor: true,
    });
  };

  addmemberSubmitHandler = e => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    e.preventDefault();
    if (this.state.meetingroom_code == null) {
      // toast.configure();
      toast.success('Please Enter Room Name', {
        //
      });
    } else if (this.state.room_type == null) {
      // toast.configure();
      toast.success('Please Enter Room Type', {
        //
      });
    } else if (this.state.status == null) {
      // toast.configure();
      toast.success('Please Select Status', {
        //
      });
    } else if (this.state.no_of_seats == null) {
      // toast.configure();
      toast.success('Please Seat Capacity', {
        //
      });
    } else if (this.state.time_slot == null) {
      // toast.configure();
      toast.success('Please Enter Booking Slot Minutes*', {
        //
      });
    } else if (this.state.price_per_slot == null) {
      // toast.configure();
      toast.success('Please Enter Price Per Slot', {
        //
      });
    } else if (this.state.price_per_slot == null) {
      // toast.configure();
      toast.success('Please Enter Price Per Slot', {
        //
      });
    } else if (this.state.price_per_slot == null) {
      // toast.configure();
      toast.success('Please Enter Price Per Slot', {
        //
      });
    } else {
      this.setState({ errorLogin: true });
 
      let param = {
        clientId: newCompanyId.organizationId,
        name: this.state.meetingroom_code,
        thumbnailImage: this.state.image,
       
        propertyId: this.state.selectedBuildingId,
        floorId: this.state.selectedFloorId,
        isPublic: true,
        type: this.state.room_type,
        isActive: this.state.status,
        capacity: this.state.no_of_seats,
        timeSlot: this.state.time_slot,
        pricePerSlot: this.state.price_per_slot,
        isAvailableAllTime: this.state.meeting_alltime,
        openTime: this.state.meeting_opentime,
        closeTime: this.state.meeting_closetime,
        added_by: this.state.added_by,
 
        booking_slot_timelimit: 1,
      };

      this.props.RoomAdd(param);

      this.setState({
        meetingroom_code: '',
        room_image: null,
        building_id: '',
        tower_id: '',
        floor_id: '',
        room_type: '',
        status: '',
        no_of_seats: '',
        time_slot: '',
        price_per_slot: '',
        meeting_alltime: '',
        meeting_opentime: '',
        meeting_closetime: '',
        dataAdd: true,
      });
    }
  };

  togglecheked = e => {
    const isChecked = e.target.checked;
    this.setState({
      [e.target.name]: isChecked,
      hidVal: isChecked, // Set hidVal to true if checked, false otherwise
    });
  };

  handelChangeVal = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  setStatus = () => {
    if ((this.state.buildingApiData = [])) {
      this.setState({
        buildingCheck: true,
      });
    }
  };
  reload = e => {
    this.setState({
      room_image: null,
    });
  };

  // Upload Document to API
  uploadDocument = async (file) => {
    if (!file) return;
  
    this.setState({ fileName: file.name, uploading: true });
  
    try {
      // Step 1: Prepare attachment details
      const sanitizedFileName = encodeURIComponent(file.name.trim());
      const attachments = {
        bucket: "meeting-room-api",
        key: `resources/${sanitizedFileName}`,
      };
  
      // Step 2: Request upload URL from the API
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
        attachments
      );
  
      const uploadUrl = data?.uploadUrl;
      if (!uploadUrl) throw new Error("Failed to get upload URL.");
  
      // Step 3: Upload the file directly to S3 using the pre-signed URL
      await axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type || "binary/octet-stream" },
      });
  
      // Step 4: Extract the base URL (without query params)
      const trimmedUrl = uploadUrl.split("?")[0];
  
      // Step 5: Update the state with the cleaned image URL
      this.setState({ image: trimmedUrl, uploading: false });
  

    } catch (error) {
      console.error("Error uploading file:", error);
      this.setState({ uploading: false });
    }
  };
  
  

  handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      await this.uploadDocument(file);
    }
  };

  handleDiscard = () => {
    this.setState({ image: null, fileName: null });
  };







  componentWillReceiveProps(props) {
    this.setState({
      trainingRoomList:
        props.roomTraingReducer && props.roomTraingReducer.RoomTrainingData,
    });
    if (props.CityNameReducer && props.CityNameReducer.length != 0) {
      this.setState({
        cityApiData: props.CityNameReducer,
      });
    }
    if (props.BuildingReducer && props.BuildingReducer.length != 0) {
      this.setState({
        buildingApiData: props.BuildingReducer,
        setFlagCity: true,
      });
    }
    if (props.TowerReducer && props.TowerReducer.length != 0) {
      this.setState({
        TowerApiData: props.TowerReducer,
        setFlagCity: true,
      });
    }
    if (props.FloorReducer && props.FloorReducer.length != 0) {
      this.setState({
        FloorApiData: props.FloorReducer,
        setFlagCity: true,
      });
    }

    if (
      this.state.dataAdd == true &&
      props.AddRoomResults &&
      props.AddRoomResults.data &&
      props.AddRoomResults.data.status == 200
    ) {
      this.setState({
        dataAdd: false,
      });
      this.setState({ errorLogin: true });
      //   const formData = new FormData();
      //   formData.append("pgno", this.props.pgNumber);
      //   formData.append("num_row", this.props.pgRowNumber);
      //   formData.append("company_id", this.state.company_id);
      const param = {
        pgno: this.props.pgNumber,
        num_row: this.props.pgRowNumber,
        company_id: this.state.company_id,
      };
      this.props.RoomMaList(param);
    }
  }
  // Fetch building data from the API
  fetchBuildingData = async () => {
    let organizationId = JSON.parse(localStorage.getItem('headData'));

    try {
      const requestData = {
        ids: [organizationId.organizationId], // List of organization IDs you want to query
        includes: ['properties'], // Any other related properties (e.g., cities)
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/all`,
        requestData,
      );

      // Extract building options
      const buildingOptions = response?.data?.data[0]?.properties?.map(
        property => ({
          value: property.id,
          label: property.name, // Building name
          properties: property, // Attach the property object to later fetch floors
        }),
      );

      // Set the building options in the state
      this.setState({ buildingOptions });
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  // Handle building change (populate floor options based on the selected building)
  handleBuildingChange = selectedBuilding => {
    const { buildingOptions } = this.state;

    // Find the selected building from the building options
    const building = buildingOptions.find(
      building => building.value === selectedBuilding.value,
    );

    if (building) {
      // Extract the floors for the selected building
      const floorOptions =
        building.properties?.floors?.map(floor => ({
          value: floor.id,
          label: floor.name, // Floor name
        })) || [];

      // Set the selected building and floor options
      this.setState({
        selectedBuilding: selectedBuilding,
        selectedBuildingId: selectedBuilding.value, // Store the full building object
        floorOptions, // Set floor options
        selectedFloor: null, // Reset the selected floor
      });
    }
  };

  // Handle floor change
  handleFloorChange = selectedFloor => {
    this.setState({
      selectedFloor, // Store the selected option object
      selectedFloorId: selectedFloor ? selectedFloor.value : null, // Save only the value (ID)
    });
  };

  // ComponentDidMount to fetch building data
  componentDidMount() {
    this.fetchBuildingData();
  }

  // Function to handle City change

  /*1---setCity---*/
  SetCityValue = city => {
    // let params = {
    //   company_id: this.state.company_id,
    // };
  };

  BookStartTimeMethod = bookStart => {
    this.setState({ meeting_opentime: bookStart.value });
  };
  BookEndTimeMethod = bookEnd => {
    this.setState({ meeting_closetime: bookEnd.value });
  };

  RoomTypemethod = room => {
    this.setState({ room_type: room.value });
  };
  /*1---setCity---*/
  /*2---getCityDAta---*/
  CityNameMethod = city => {
    this.setState({ city: city.value });
    let params = {
      company_id: this.state.company_id,
      cityid: city.value,
    };
    this.props.buildingFilterAction(params);
  };
  /*2---getCityDAta---*/
  /*3---Building---*/
  buildingNameMethod = building => {
    this.setState({ building_id: building.value });
    let params = {
      company_id: this.state.company_id,
      buildingid: building.value,
    };
    this.props.TowerFilterAction(params);
    this.props.FloorFilterAction(params);
  };
  /*3---Building---*/
  TowerNameMethod = building => {
    this.setState({ tower_id: building.value });
    let pars = {
      buildingid: this.state.building_id,
      tower_id: building.value,
      company_id: this.state.company_id,
    };
    this.props.FloorFilterAction(pars);
  };
  FloorNameMethod = building => {
    this.setState({ floor_id: building.value });
  };

  render() {
    const RoomManagement = this.state.userRole.find(
      element => element.service_id == '4',
    );
    const {
      buildingOptions,
      floorOptions,
      selectedBuilding,
      selectedFloor,
    } = this.state;

    const roomType = [
      {
        value: 'Meeting Room',
        label: 'Meeting Room',
      },
      {
        value: 'Training Room',
        label: 'Training Room',
      },
      {
        value: 'Conference Room',
        label: 'Conference Room',
      },
      {
        value: 'Lounge Room',
        label: 'Lounge Room',
      },
    ];

    const bookStartTime = [
      { value: '01:00:00', label: '01:00' },
      { value: '01:30:00', label: '01:30' },
      { value: '02:00:00', label: '02:00' },
      { value: '02:30:00', label: '02:30' },
      { value: '03:00:00', label: '03:00' },
      { value: '03:30:00', label: '03:30' },
      { value: '04:00:00', label: '04:00' },
      { value: '04:30:00', label: '04:30' },
      { value: '03:00:00', label: '05:00' },
      { value: '03:30:00', label: '05:30' },
      { value: '03:00:00', label: '06:00' },
      { value: '06:30:00', label: '06:30' },
      { value: '06:00:00', label: '07:00' },
      { value: '07:30:00', label: '07:30' },
      { value: '08:00:00', label: '08:00' },
      { value: '08:30:00', label: '08:30' },
      { value: '09:00:00', label: '09:00' },
      { value: '09:30:00', label: '09:30' },
      { value: '10:00:00', label: '10:00' },
      { value: '10:30:00', label: '10:30' },
      { value: '11:00:00', label: '11:00' },
      { value: '11:30:00', label: '11:30' },
      { value: '12:00:00', label: '12:00' },
      { value: '12:30:00', label: '12:30' },
      { value: '13:00:00', label: '13:00' },
      { value: '13:30:00', label: '13:30' },
      { value: '14:00:00', label: '14:00' },
      { value: '14:30:00', label: '14:30' },
      { value: '15:00:00', label: '15:00' },
      { value: '15:30:00', label: '15:30' },
      { value: '16:00:00', label: '16:00' },
      { value: '16:30:00', label: '16:30' },
      { value: '17:00:00', label: '17:00' },
      { value: '17:30:00', label: '17:30' },
      { value: '18:00:00', label: '18:00' },
      { value: '18:30:00', label: '18:30' },
      { value: '19:00:00', label: '19:00' },
      { value: '19:30:00', label: '19:30' },
      { value: '20:00:00', label: '20:00' },
      { value: '20:30:00', label: '20:30' },
      { value: '21:00:00', label: '21:00' },
      { value: '21:30:00', label: '21:30' },
      { value: '22:00:00', label: '22:00' },
      { value: '22:30:00', label: '22:30' },
      { value: '23:00:00', label: '23:00' },
      { value: '23:30:00', label: '23:30' },
      { value: '24:00:00', label: '24:00' },
    ];

    //--City--///
    const cityOption = [];
    if (this.state.cityApiData !== 0) {
      this.state.cityApiData &&
        this.state.cityApiData.map((items, i) => {
          cityOption.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--Building---///
    const buildingOption = [];
    if (this.state.buildingApiData !== 0) {
      this.state.buildingApiData &&
        this.state.buildingApiData.map((items, i) => {
          buildingOption.push({
            value: items.building_id,
            label: items.building_name,
          });
        });
    }
    //--Building--///
    //--Tower---///
    const towerOption = [];
    if (this.state.TowerApiData !== 0) {
      this.state.TowerApiData &&
        this.state.TowerApiData.map((items, i) => {
          towerOption.push({
            value: items.tower_id,
            label: items.tower_name,
          });
        });
    }
    //--Tower---///
    //--Floor--///
    const FloorOption = [];
    if (this.state.FloorApiData !== 0) {
      this.state.FloorApiData &&
        this.state.FloorApiData.map((items, i) => {
          FloorOption.push({
            value: items.floor_id,
            label: items.floor_name,
          });
        });
    }
    //--Floor---///

    return (
      <>
        <SwOffCanvas
          show={this.state.showOffcanvas}
  onClose={() => this.setState({ showOffcanvas: false })}
  title="Add New Room"
  placement="end"
  className="sw-default-offcanvas"
  footer={
    <div className="d-flex justify-content-end gap-3">
      <SwButton
      variant='dark-outline'
      
        type="button"
        onClick={this.reload}
      >
        Reset
      </SwButton>

      <SwButton
      
        onClick={this.addmemberSubmitHandler}
      >
        Add Details
      </SwButton>
    </div>
  }
        >
  <from>
                  <div className="row">
          <div className="row mb-4">
      <div className="col-md-8">
    <AntDUpload
    type=""
    listType="picture-card"
    multiple={false}
    autoUpload={false}
    fileList={this.state.uploadList}
    disabled={this.state.uploading}
    onChange={({ fileList }) => {
      this.setState({ uploadList: fileList }, async () => {
        const fileObj = fileList[0];

        if (fileObj && !fileObj.uploaded) {
          const file = fileObj.originFileObj;
          await this.uploadDocument(file);
          fileObj.uploaded = true;
        }
      });
    }}
  >
    + Upload
  </AntDUpload>
</div>
          </div>
        </div>

                    <div className="row pt40">
                      <div className="col-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Room Name <span className="Required">*</span></label>
                          <SwInput
                          type="text"
                          name="meetingroom_code"
                          maxLength="20"
                          value={this.state.meetingroom_code}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Room Booking'
                          isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className="SwFormLabel">Building<span className="Required">*</span></label>
                          <SwSelect
                            onChange={this.handleBuildingChange}
                            options={buildingOptions}
                            value={selectedBuilding || null}
                            placeholder='Select Building Name'
                            isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Floor Name<span className="Required">*</span></label>
                          <SwSelect
                            onChange={this.handleFloorChange}
                            options={floorOptions}
                            value={
                              selectedFloor
                                ? floorOptions.find(
                                    floor => floor.value === selectedFloor,
                                  )
                                : null
                            }
                            placeholder="Select Floor name"
                            isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Room Type<span className="Required">*</span></label>
                          <SwSelect
                            name="room_type"
                            onChange={this.RoomTypemethod}
                            options={roomType}
                            placeholder="Select Room type"
                            isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Status<span className="Required">*</span></label>
                          <div onChange={this.handelChangeVal}>
                            <SwRadio
                                  id="status-active"
                                  name="status"
                                  value="true"
                                  label="Active"
                                  checked={this.state.status === "true"}
                                  onChange={this.handelChangeVal}
                                />
                                <SwRadio
                                    id="status-inactive"
                                    name="status"
                                    value="false"
                                    label="Inactive"
                                    checked={this.state.status === "false"}
                                    onChange={this.handelChangeVal}
                                  />
                        </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Seating Capacity<span className="Required">*</span></label>
                          <SwInput
                          type="number"
                          name="no_of_seats"
                          min={0}
                          maxLength="4"
                          value={this.state.no_of_seats}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Seating Capacity'
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking Slot Minutes<span className="Required">*</span></label>
                          <SwInput
                          type="number"
                          min={0}
                          name="time_slot"
                          maxLength="4"
                          value={this.state.time_slot}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Booking Slot Minutes'
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Price Per Slot<span className="Required">*</span></label>
                          <SwInput
                          type="number"
                          name="price_per_slot"
                          maxLength="4"
                          min={0}
                          value={this.state.price_per_slot}
                          onChange={this.handelChangeVal}
                          placeholder='Enter Price Per Slot'
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>24 x 7 Booking Allowance<span className="Required">*</span></label>
                          <label
                            class={
                              (this.state.setcolor = true
                                ? 'switch color'
                                : 'switch')
                            }
                            onClick={this.setColor}
                          >
                          </label>
                                             <SwSwitchButtons
    id="meeting-alltime"
    name="meeting_alltime"
    checked={this.state.meeting_alltime}
    onChange={this.togglecheked}
    size="lg"
  />
                                                                               <br />
                          <span className="smText">
                            Facilitate 24 x 7 availability of meeting rooms.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={this.state.hidVal ? 'row disp' : 'row '}>
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking Start Time<span className="Required">*</span></label>
                          {/* <select
                            name="meeting_opentime"
                            value={this.state.meeting_opentime}
                            onChange={this.handelChangeVal}
                            className="form-control"
                          > */}
                          <SwSelect
                            name="meeting_opentime"
                            onChange={this.BookStartTimeMethod}
                            options={bookStartTime}
                            placeholder='Select Start time'
                            isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={this.state.hidVal ? 'row disp' : 'row '}>
                      <div className="col-md-12 col-xl-12 col-lg-12">
                        <div className="SwFormGroup">
                          <label className='SwFormLabel'>Booking End Time<span className="Required">*</span></label>
                          <SwSelect
                            name="meeting_closetime"
                            onChange={this.BookEndTimeMethod}
                            options={bookStartTime}
                            placeholder='Select End time'
                            isClearable={false}
                          />
                        </div>
                      </div>
                    </div>
                  </from>
        </SwOffCanvas>
        {(RoomManagement && RoomManagement.role_for_write == '1' ? (
          true
        ) : (
          false
        )) ? (
           <SwButton
            size='sm'
            type="button"
            icon={<i class="bi bi-plus-circle"></i>}
            onClick={() => this.setState({ showOffcanvas: true })}
          >
            Add Room
          </SwButton>
                ) : (
                  ''
                )}
              </>
            );
          }
        }

        const mapStateToProps = state => ({
          roomTraingReducer: state.roomTraingReducer,
          CityNameReducer: state.roomTraingReducer.TrainingRoomCityData,
          BuildingReducer: state.roomTraingReducer.TrainingRoomBuilding,
          TowerReducer: state.roomTraingReducer.TrainingRoomTower,
          FloorReducer: state.roomTraingReducer.TrainingRoomFloor,
          AddRoomResults: state.roomTraingReducer.AddRoomResults,
        });

        const mapActionsToProps = {
          RoomAdd,
          RoomMaList,
          CityFilterAction,
          buildingFilterAction,
          TowerFilterAction,
          FloorFilterAction,
        };

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(AddRoom);
